export const environment = {
  production: true,
  buildId: '2885435011119691',
  configFile: 'config.json',
};
